import React from "react";
import {
  BeadCrumb,
  Typography,
  OnboardingDetails,
} from "components";

const ValidatedKYC = () => {
  return (
    <div className="dashboard-page-container">
      <div className="d-flex justify-content-between align-items-center">
        <BeadCrumb
          titles={["Approvals", "Accounts", "Awaiting Approval"]}
        />
        <div>
          <Typography variant="caption1" className={"text-center"}>
            Account Status:
          </Typography>
          <Typography state="primary" variant="body2">
            KYC validated, pending approval
          </Typography>
        </div>
      </div>
      <div style={{ marginTop: "3rem" }}>
        <Typography
          variant={"heading3"}
          state="primary"
          className={"text-center"}
        >
          New Account Awaiting Approval
        </Typography>
      </div>
      <div style={{ marginTop: "3rem" }}>
        <OnboardingDetails />
      </div>
    </div>
  );
};

export default ValidatedKYC;
